import { Injectable, OnDestroy } from '@angular/core';
import { GeneralService } from './general.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SnackBarService } from './snackbar.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { AppLoadingService } from './apploading.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AuthState } from 'src/app/core/auth/auth-state';
import { MatDialog } from '@angular/material/dialog';
import { DialogActionComponent } from '../components/dialog-action/dialog-action.component';

@Injectable({
    providedIn: 'root'
})
export class FollowService implements OnDestroy {


    private following = {
        ad: [],
        person: []
    };

    private lastResult = [];
    

    private followingSubject = new BehaviorSubject<any>(0);
    following$ = this.followingSubject.asObservable();

    private followingActionSubject = new BehaviorSubject<any>(0);
    followingAction$ = this.followingActionSubject.asObservable();

    private followingDataSubject = new BehaviorSubject<any>(0);
    followingData$ = this.followingDataSubject.asObservable();

    protected personDataSubscription: Subscription;

    constructor(
        protected httpService : HttpService,
        protected gs: GeneralService,
        private snackBarService: SnackBarService,
        protected als : AppLoadingService,
        protected auth: AuthService,
        public dialog: MatDialog
    ) {
        

        this.auth.getAuthStateChange().subscribe(result => {
            if(result.state == AuthState.SIGNED_OUT)
                this.followingSubject.next(0);
        });

        this.personDataSubscription = this.gs.generalData$.subscribe((result) => {
            this.getTotalFollowing();    
        });
    }

    ngOnDestroy(){
        this.personDataSubscription?.unsubscribe();
    }

    updateList(type, data){
        this.following[type] = data;
        this.totalFollowing();
    }

    getTotalFollowing() {
        let data = this.gs.getGeneralData();
        this.following.ad = data?.followingAds || [];
        this.following.person = data?.followingPersons || [];
        this.totalFollowing();
    }

    isFollow(type, id) {
        return typeof this.following[type] != 'undefined' && this.following[type].indexOf(parseInt(id)) > -1;
    }

    totalFollowing() {
        let sum = 0;
        Object.entries(this.following).forEach(([key, value]) => sum += value.length);
        this.followingSubject.next(sum);
        return sum;

    }

    follow(type, data):Promise<any> {
        console.log(type, data);
        if(!data)
            return;

        if (this.isFollow(type,  data?.personId || data?.id || data?.adId))
            return this.stopFollow(type, data);
        else
            return this.startFollow(type, data);
    }

    followBusiness(data){
        
        if(!this.isFollow('person', data?.ownerPublicIdText || data?.ownerPersonId || data?.owner?.personId)){
            const dialogRef2 = this.dialog.open(DialogActionComponent, 
                {disableClose : true,
                 data: {
                    title: 'Empresa '+(data?.ownerName || data?.owner?.personName || ''),
                    content: 'Adicionar aos favoritos?',
                    cancelTitle: 'Não',
                    okTitle: 'Sim'
                }});
    
            dialogRef2.afterClosed().subscribe(result => {
                console.log(data);
                if(result)
                  this.follow('person', {type:'person', id:data?.ownerPublicIdText || data?.ownerPersonId || data?.owner?.personId, title: data?.ownerName || data?.owner?.personName || ''})
            });
        }
    }

    private async startFollow(type, data){
        let id = data?.adId || data?.id;

        if(id)
            this.gs.event('follow',{id:id, type: type});

        let coordinates = await this.gs.getCurrentPosition();

        this.followingActionSubject.next({action:'loading', id:id});

        return await this.httpService.post<any>(API[type].general.follow, {id : id, ...coordinates})
            .then((result) => {
                this.following[type].push(parseInt(id));
                this.totalFollowing();
                if(type == 'ad')
                    this.followBusiness(data);

                this.followingActionSubject.next({action:'start', id:id});
            })
            .catch(err => {
                this.gs.error(err);
                this.followingActionSubject.next({action:'error', id:id});
            });
    }
    private async stopFollow(type, data){
        let id = data?.adId || data?.id;

        this.followingActionSubject.next({action:'loading', id:id});

        return await this.httpService.del<any>(API[type].general.follow, {id : id})
            .then((result) => {
                this.following[type] = this.following[type].filter(item => item != id);
                this.totalFollowing();
                this.followingActionSubject.next({action:'stop', id:id});                  
            })
            .catch(err => {
                this.gs.error(err);
                this.followingActionSubject.next({action:'error', id:id});
            });
    }


    getFollowing(){
        this.als.setLoaded(false, 'followingList');
        this.httpService.post<any>(API.user.general.following, {})
            .then((result) => {
                this.lastResult = result;
                this.updateFollowing();
                this.followingDataSubject.next(this.prepareFollowingList(result));
            })
            .catch(err => console.log(err))
            .finally(() => this.als.setLoaded(true, 'followingList'));
    }

    updateFollowing(data:any = false){
        this.followingDataSubject.next(data || this.prepareFollowingList(this.lastResult));
    }

    prepareFollowingList(data){
        return {persons:data?.persons, ads : data?.ads?.hits}
    }
}